export const PHONE_COUNTRY_CODE = 'CL';
